import { z } from 'zod';

export const DISPOSAL_PURPOSE_SCHEMA = z.enum(['RECYCLING', 'DISPOSAL']);

export type DISPOSAL_PURPOSE = z.infer<typeof DISPOSAL_PURPOSE_SCHEMA>;
